import { htmlEscape } from 'escape-goat';
export default function MergeFieldsPlugin(initialMergeFields, _ref) {
  let {
    ariaLabelMergeFieldDropdown = 'Merge Codes',
    ariaLabelMergeFieldOther = 'Other',
    toolbar = 'merge_field',
    toolbarAttributes = {
      style: 'width: 500px'
    },
    onMergeFieldSelected
  } = _ref;
  let currentMergeFields = initialMergeFields;
  return _ref2 => {
    let {
      editor
    } = _ref2;
    let mergeFieldMap = buildMergeFieldMap(initialMergeFields);
    editor.updateMergeFieldsRef = function (newMergeFields) {
      currentMergeFields = newMergeFields;
      mergeFieldMap = buildMergeFieldMap(newMergeFields);
      const isPluginVisible = determineMergeFieldsPluginVisibility(mergeFieldMap);
      const pluginElement = document.querySelector('.cke_combo__mergecodes');
      if (!pluginElement) return;
      if (isPluginVisible) {
        pluginElement.style.display = 'inline-block';
      } else {
        pluginElement.style.display = 'none';
      }
    };
    const findMergeCodeObjectByEditorCode = editorCode => {
      const mergeCode = mergeFieldMap[editorCode];
      if (mergeCode) {
        return mergeCode;
      }
      return mergeCode;
    };
    let frameAlreadyBuilt = false;
    function buildList(mergeFields) {
      if (frameAlreadyBuilt) {
        // Remove the old unordered list from the dom.
        // This is just to cleanup the old list within the iframe
        const id = this._.panel.element.$.id;
        const iframeContent = document.querySelector("#".concat(id, " iframe"));
        if (!iframeContent || !iframeContent.contentWindow || !iframeContent.contentWindow.document) return;
        const content = iframeContent.contentWindow.document.querySelector('.cke_panel_block');
        if (!content) return;
        content.innerHTML = '';

        // reset list
        this._.items = {};
        this._.list._.items = {};
      }
      if (mergeFields.groups) {
        mergeFields.groups.forEach(group => {
          this.startGroup(group.label);
          group.fields.forEach(field => {
            this.add(field.id, field.label, field.label);
          });
        });
      }
      if (mergeFields.groups && mergeFields.groups.length > 0 && mergeFields.fields && mergeFields.fields.length > 0) {
        this.startGroup(ariaLabelMergeFieldOther);
      }
      if (mergeFields.fields) {
        mergeFields.fields.forEach(field => {
          this.add(field.id, field.label, field.label);
        });
      }
      if (frameAlreadyBuilt) {
        this._.committed = 0; // We have to set to false in order to trigger a complete commit()
        this.commit();
      }
      frameAlreadyBuilt = true;
    }
    editor.ui.addRichCombo('mergecodes', {
      label: ariaLabelMergeFieldDropdown,
      title: ariaLabelMergeFieldDropdown,
      toolbar: toolbar,
      panel: {
        multiSelect: false
      },
      attributes: {
        "aria-label": ariaLabelMergeFieldDropdown,
        ...toolbarAttributes
      },
      init: function (widget) {
        var rebuildList = buildList.bind(this);
        rebuildList(currentMergeFields);
        editor.rebuildMergeFields = rebuildList;
        const id = this._.panel.element.$.id;
        const widgetHead = document.querySelector("#".concat(id, " iframe")).contentWindow.document.head;
        widgetHead.innerHTML += "\n                    <style type=\"text/css\">\n                        ul {\n                            list-style: none;\n                            margin: 0;\n                            padding: 0;\n                            position: relative;\n                        }\n                        li {\n                            padding-top: 6px;\n                            padding-bottom: 6px;\n                            box-sizing: border-box;\n                            white-space: nowrap;\n                            padding-left: 16px;\n                            padding-right: 16px;\n                        }\n                        li a {\n                            display: block;\n                            font-family: \"Open Sans\",\"Helvetica Neue\",Arial,sans-serif;\n                            font-weight: 400;\n                            font-size: 14px;\n                            color: black;\n                            text-decoration: none;\n                            -webkit-tap-highlight-color: transparent;\n                            -webkit-touch-callout: none;\n                            -webkit-user-select: none;\n                            -khtml-user-select: none;\n                            -moz-user-select: none;\n                            -ms-user-select: none;\n                            user-select: none;\n                            outline: none;\n                            outline-style: none;\n                            box-shadow: none;\n                            border-color: transparent;\n                        }\n                        li:hover, li:focus-within {\n                            cursor: pointer;\n                            text-decoration: none;\n                            background-color: rgba(0, 0, 0, 0.04);\n                        }\n                        h1 {\n                            font-size: 17px;\n                            padding-top: 6px;\n                            padding-bottom: 6px;\n                            box-sizing: border-box;\n                            white-space: nowrap;\n                            padding-left: 16px;\n                            padding-right: 16px;\n                            margin: 0px;\n                            font-family: \"Open Sans\",\"Helvetica Neue\",Arial,sans-serif;\n                            font-weight: 500;\n                        }\n                        \n                    </style>\n                ";
      },
      onClick: function (mergeFieldId) {
        editor.focus();
        editor.fire("saveSnapshot");
        const mergeField = findMergeCodeObjectByEditorCode(mergeFieldId);
        handleMergeValue(editor, mergeField);
        if (typeof onMergeFieldSelected === 'function') {
          onMergeFieldSelected(mergeField);
        }
        editor.fire("saveSnapshot");
      }
    });
  };
}
function handleMergeValue(editor, mergeField) {
  if (typeof mergeField.mergeValue === 'string') {
    handleMergeString(editor, mergeField.mergeValue);
  } else if (typeof mergeField.mergeValue === 'object') {
    if (!Array.isArray(mergeField.mergeValue)) {
      handleMergeObject(editor, mergeField);
    }
  }
}
function handleMergeString(editor, mergeFieldStr) {
  editor.insertHtml(htmlEscape(mergeFieldStr));
}
function handleMergeObject(editor, mergeField) {
  if (mergeField.mergeValue.__dangerouslyProcessAsHTML === true) {
    // @ts-ignore
    const element = CKEDITOR.dom.element.createFromHtml(mergeField.mergeValue.value);
    editor.insertElement(element);
  } else {
    // sanitize value being passed
    editor.insertHtml(htmlEscape(mergeField.mergeValue.value));
  }
}
function buildMergeFieldMap(mergeFields) {
  const map = {};
  if (mergeFields.fields && Array.isArray(mergeFields.fields)) {
    mergeFields.fields.forEach(field => {
      if (map[field.id]) {
        console.warn("Merge field id: ".concat(field.id, " already exists"));
      }
      map[field.id] = field;
    });
  }
  if (mergeFields.groups && Array.isArray(mergeFields.groups)) {
    mergeFields.groups.forEach(group => {
      if (group.fields && Array.isArray(group.fields)) {
        group.fields.forEach(field => {
          if (map[field.id]) {
            console.warn("Merge field id: ".concat(field.id, " already exists"));
          }
          map[field.id] = field;
        });
      }
    });
  }
  return map;
}
function determineMergeFieldsPluginVisibility(mergeFields) {
  return Object.keys(mergeFields).length !== 0;
}